import { Box, Button, Typography } from "@mui/material";
import MainLayout from "layouts/Main";
import { Link } from "react-router-dom";

const NotFound = () => (
  <MainLayout>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        mt: "4rem",
      }}
    >
      <Typography variant="h3" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h6" component="p" gutterBottom>
        The page you are looking for does not exist.
      </Typography>
      <Button component={Link} to="/" variant="contained" sx={{ mt: "1rem" }}>
        Go to home page
      </Button>
    </Box>
  </MainLayout>
);

export default NotFound;
